skrilla.controller('skrillaJobsCtrl', function ($scope, searchService) {
    $scope.key = "skrillaJobs";
    $scope.tabs = [
        {title: "Avatars Loading Job", active: true},
        {title: "Skrilla Reconcilliation", active: false},
        {title: "Promotions", active: false},
        {title: "Access Control"},
        {title: "Email Subscriptions"}
    ];

    $scope.csgoOutlookDays = 1;
    $scope.lolOutlookDays = 1;


    $scope.avatarJob = function(){
        searchService.post("skrillaJobs/loadAvatars", {}, "Avatar Job successfully run");
    }

    $scope.reconcile = function(){
        searchService.get("skrillaJobs/reconcileSKR").then(function(response){
            swal("Success!", "SKR reconciliation Job successfully run", "success");
        });
    }

    $scope.showEndPointMappings = function(){
        searchService.get("skrillaJobs/getEndpoints").then(function(response){
            $scope.endPoints = response.data;
        });
    }

    $scope.migrateSparkpostSuppressions = function(){
        searchService.put("emailSubscriptions/sparkpostMigration",  $scope.emailMigration,
            "Email migration in process. A message will be sent to slack on completion")
    }


    $scope.claimDefaultDeposit = function(){
        searchService.post("skrillaJobs/claimDepositBonuses", {}, "Success");
    }

});